import type { FC } from "react";
import {
  ActionIcon,
  Box,
  Group,
  Paper,
  Text,
  ThemeIcon,
  type MantineColor,
} from "@mantine/core";
import { IconDownload, IconFileText, IconTrash } from "@tabler/icons-react";
import { ICON_STROKE } from "./order-page-v2.utils";

const FILE_THUMB_FONT_SIZE = 9;
const FILE_THUMB_COLORS: Partial<Record<string, MantineColor>> = {
  PDF: "danger",
  STL: "brand",
};

const FileThumb: FC<{ extension: string }> = ({ extension }) =>
  extension ? (
    <ThemeIcon
      variant="filled"
      color={FILE_THUMB_COLORS[extension] ?? "ink"}
      size="lg"
      radius="sm"
    >
      <Text fz={FILE_THUMB_FONT_SIZE} fw={700} c="white">
        {extension.slice(0, 4)}
      </Text>
    </ThemeIcon>
  ) : (
    <ThemeIcon variant="light" color="ink" size="lg" radius="sm">
      <IconFileText size={18} stroke={ICON_STROKE} />
    </ThemeIcon>
  );

type OrderFileRowProps = {
  name: string;
  extension: string;
  meta: string;
  onDownload: () => void;
  onDelete?: () => void;
};

export const OrderFileRow: FC<OrderFileRowProps> = ({
  name,
  extension,
  meta,
  onDownload,
  onDelete,
}) => (
  <Paper withBorder p="s3" radius="md">
    <Group wrap="nowrap" gap="s3">
      <FileThumb extension={extension} />
      <Box flex={1} miw={0}>
        <Text variant="strong" truncate="end">
          {name}
        </Text>
        <Text variant="caption">{meta}</Text>
      </Box>
      <ActionIcon
        variant="subtle"
        color="ink"
        aria-label={`Télécharger ${name}`}
        onClick={onDownload}
      >
        <IconDownload size={16} stroke={ICON_STROKE} />
      </ActionIcon>
      {onDelete && (
        <ActionIcon
          variant="subtle"
          color="danger"
          aria-label={`Supprimer ${name}`}
          onClick={onDelete}
        >
          <IconTrash size={16} stroke={ICON_STROKE} />
        </ActionIcon>
      )}
    </Group>
  </Paper>
);
